import { Card } from "reactstrap";
import { uniqueId } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";

import { Header } from "./Header";
import { Footer } from "./Footer";
import { DetailsSection } from "./DetailsSection";
import { ThumbnailSection } from "./ThumbnailSection";
import "../Styles/GridCard.scss";
import FirstVideoAnalyzedStep2 from "../../../Shared/Tutorials/FirstVideo/FirstVideoAnalyzedStep2";

const GridCard = ({
  item,
  note,
  cardType,
  handleOpenSinglePublish,
  handleLinkClick,
  videoProducts,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isAppManager = location.pathname === "/published";

  const redirectTo = (cardType, itemId) => {
    if (isAppManager) {
      navigate(`/published/${itemId}`);
    } else {
      navigate(`/${cardType.toLowerCase()}s/${itemId}`);
    }
    handleLinkClick();
  };

  const renderHeaders = () => {
    switch (cardType) {
      case "Product":
        return <Header item={item} />;
      default:
        return null;
    }
  };

  const renderFooter = () => {
    switch (cardType) {
      case "Product":
        return <Footer item={item} product_edit={true} />;
      default:
        return null;
    }
  };

  const reArrangeItem =
    cardType === "Video" ? { ...item, ...item.video } : item;

  return (
    <>
      <FirstVideoAnalyzedStep2 />
      <Card
        key={uniqueId()}
        className={`CardContent-${cardType}`}
        onClick={(e) => {
          e.preventDefault();
          redirectTo(cardType, reArrangeItem._id);
        }}
      >
        {renderHeaders()}
        <ThumbnailSection
          cardType={cardType}
          item={reArrangeItem}
          handleOpenSinglePublish={handleOpenSinglePublish}
        />
        <DetailsSection
          cardType={cardType}
          item={reArrangeItem}
          videoProducts={videoProducts}
          note={note}
        />
        {renderFooter()}
      </Card>
    </>
  );
};

export default GridCard;
